import { Box, Typography } from "@mui/material";
import React from "react";

const FoodTypeLegend = () => {
  const types = [
    { label: "Veg", color: "green" },
    { label: "Non-Veg", color: "red" },
    { label: "Egg", color: "orange" },
  ];

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, ml: "auto" }}>
      {types.map((type) => (
        <Box
          key={type.label}
          sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
        >
          <Box
            sx={{
              width: 14,
              height: 14,
              border: `1px solid ${type.color}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                bgcolor: type.color,
              }}
            />
          </Box>
          <Typography variant="body2">{type.label}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default FoodTypeLegend;
